
import { useNavigate } from "react-router-dom";
import { host } from "../../../callApi/AxiosCall";
import { getProductApi } from "../../../callApi/productApi";
import CustomButton from "../../../components/CustomButton";
import CustomInput from "../../../components/CustomInput";
import CustomInputProduct from "../../../components/CustomInputProduct";
import CustomHeader from "../../../components/admin/CustomHeader";
import CustomLeftBar from "../../../components/admin/CustomLeftBar";
import CustomPagination from "../../../components/admin/CustomPagination";
import Notiflix from "notiflix";
import React, { useEffect, useState } from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export default function AdminProducts() {
  const [nowPage, setnowPage] = useState(1);
  const [allPage, setallPage] = useState(1);
  const [AllData, setAllData] = useState([1, 2, 3, 4, 5, 6, 7]);
  const [PostData, setPostData] = useState(null);
  const [productItem, setproductItem] = useState(null);
  const [searchValue, setsearchValue] = useState("");
  const router = useNavigate();
  const [year, setyear] = useState({
    name: "ทั้งหมด",
    value: { start_date: "", end_date: "" },
  });
  const typeYear = [
    {
      name: "ทั้งหมด",
      value: { start_date: "", end_date: "" },
    },
    {
      name: "2024",
      value: { start_date: "2024-01-01", end_date: "2024-12-31" },
    },
    {
      name: "2023",
      value: { start_date: "2023-01-01", end_date: "2023-12-31" },
    },
  ];
  useEffect(() => {
    if (nowPage) CallPost();
  }, [nowPage, year]);
  const CallPost = async () => {
    Notiflix.Loading.circle();
    let res = await getProductApi({
      limit: 10,
      page: nowPage,
      end_date: year?.value?.end_date ?? "",
      start_date: year?.value?.start_date ?? "",
      search: searchValue,
    });
    Notiflix.Loading.remove();
    if (res.status == 200) {
      setPostData(res.data.data.products);
      setallPage(Math.ceil(res?.data?.data?.count / 10));
    }
  };
  return (
    <div className="flex flex-col h-screen">
      <CustomHeader />
      <div className="flex flex-row flex-[1] overflow-hidden">
        <CustomLeftBar page="Products" subPage="Circular Design" />
        <div className="p-8 flex flex-col items-center flex-[1] overflow-y-auto">
          <div className="flex flex-row justify-between w-full gap-3">
            <p className=" text-[24px] w-full font-semibold">
              ผลิตภัณฑ์ท้องถิ่น
            </p>
            {/* <CustomInputProduct
              value={dateFilter}
              onChange={(v) => setdateFilter(v)}
              title="filter"
              placeHolder="filter"
              type={"select"}
              data={[
                {name:'ทั้งหมด',startDate:null,endDate:null},
                {name:'2566',startDate:'2023-12-1',endDate:'2023-1-1'},
                {name:'2567',startDate:'2024-12-1',endDate:'2024-1-1'},
              ]}
              fontSize={14}
            /> */}

            <div className="self-center w-44">
              <CustomInputProduct
                type="select"
                value={year}
                data={typeYear}
                placeHolder="เลือกปี"
                onChange={(item) => {
                  setyear(item);
                }}
              />
            </div>
            <CustomInput
              value={searchValue}
              onChange={(v) => setsearchValue(v)}
              placeHolder="ค้นหา"
              rightImg={"/img/Search.png"}
              onEnter={() => {
                setnowPage(1)
                CallPost();
              }}
            />
          </div>
          <div className="overflow-x-auto w-full flex-[1] my-5">
            <div className="min-w-[800px]  ">
              <div className="grid grid-cols-12 border">
                {/* <div className="min-w-5 p-2  font-semibold"></div> */}
                <div className="min-w-20 p-2  font-semibold text-[12px] text-center">
                  เลขทะเบียน
                </div>
                <div className="flex-[2] md:flex-[3] min-w-10 p-2  font-semibold text-[12px] text-center col-span-9">
                  รายการ
                </div>
                {/* <div className="flex-[2] md:flex-[3] min-w-10 p-2  font-semibold text-[12px] text-center">
                  รายละเอียด
                </div>
                <div className="flex-[1] md:flex-[2] min-w-10 p-2  font-semibold text-[12px] text-center">
                  ขนาด
                </div>
                <div className="flex-[1] min-w-10 p-2  font-semibold text-[12px] text-center">
                  จำนวน
                </div>
                <div className="flex-[1] min-w-10 p-2  font-semibold text-[12px] text-center">
                  ราคา/หน่วย
                </div>
                <div className="flex-[1] min-w-10 p-2  font-semibold text-[12px] text-center">
                  ราคารวม
                </div>
                <div className="flex-[1] min-w-10 p-2  font-semibold text-[12px] text-center">
                  หมายเหตุ
                </div> */}
                <div className=" min-w-[150px]  p-2  font-semibold text-[12px] text-center col-span-2">
                  การตรวจสอบ
                </div>
              </div>
              {PostData?.map((item, i) => {
                return (
                  <div
                    key={i}
                    className={
                      "grid grid-cols-12 border " +
                      (i % 2 ? "" : "bg-[#F6F7F7]")
                    }
                  >
                    {/* <div className="min-w-5 p-2  font-semibold"></div> */}
                    <div className="min-w-20 p-2  font-semibold text-[12px]">
                      {item.no}
                    </div>
                    <div
                      onClick={() => {
                        // route
                        router("/admin/products/" + item.id);
                      }}
                      className="flex-[2] flex flex-row md:flex-[3] min-w-20 p-2  font-semibold text-[12px] col-span-9"
                    >
                      {/* {item.product_img? <Zoom>
                      <img
                        src={'https://ftcdc.udru.ac.th/ftcdc-api/'+item.product_img}
                        className="h-32 object-contain"
                      />
                    </Zoom>:null}  */}
                      <p>{item.name}</p>
                    </div>
                    {/* <div className="flex-[2] md:flex-[3] min-w-10 p-2  font-semibold text-[12px]">
                      {item.technic} {item.pattern} {item.material}
                    </div>
                    <div className="flex-[1] md:flex-[2] min-w-10 p-2  font-semibold text-[12px]">
                      กว้าง : {item.width} x ยาว : {item.length} ซม.
                    </div>
                    <div className="flex-[1] min-w-10 p-2  font-semibold text-[12px] text-center">
                      {item.amount}
                    </div>
                    <div className="flex-[1] min-w-10 p-2  font-semibold text-[12px] text-center">
                      {item.price}
                    </div>
                    <div className="flex-[1] min-w-10 p-2  font-semibold text-[12px] text-center">
                      {item.price * item.amount}
                    </div> */}
                    {/* <div className="flex-[1] min-w-10 p-2  font-semibold text-[12px]">
                      {item.note}
                    </div> */}
                    <div className=" min-w-[150px]  p-2  font-semibold text-[12px] col-span-2">
                      <CustomButton
                        onClick={() => {
                          router("/admin/products/" + item.id);
                        }}
                        txt={
                          // item.circular_design?.tag_check
                          //   ? "ตรวจสอบแล้ว"
                          //   : "ไม่ผ่านการตรวจสอบ"
                          "แก้ไข"
                        }
                        leftIconName={"uil:edit"}
                        classAdditional=" text-[12px] text-center"
                        bgcolor={
                          item.circular_design?.tag_check
                            ? "#2271B1"
                            : "#9E0400"
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <CustomPagination
            now={nowPage}
            all={allPage}
            onChangePage={(page) => {
              setnowPage(page);
            }}
          />
        </div>
      </div>
    </div>
  );
}
